<!-- Skeleton Loader -->
@if (loading) {
  <div class="dash-main-content">
    <div class="dash-top">
      <h2 class="dash-title">Nouvelle application</h2>
    </div>
    <div class="add-skeleton">
      @for (_ of [1,2,3,4]; track _) {
        <div class="skeleton-card">
          <div class="skeleton-line w-40"></div>
          <div class="skeleton-line w-60"></div>
          <div class="skeleton-line w-80"></div>
        </div>
      }
    </div>
  </div>
}

<!-- Contenu réel -->
@if (!loading) {
  <div class="dash-main-content">
    <div class="dash-top">
      <div class="dash-action">
        <div class="dash-action-left">
          <h2 class="dash-title" style="margin:0;">Nouvelle application</h2>
        </div>
        <div class="dash-action-right">
          <button class="button neutral icon medium" (click)="resetForm()" [disabled]="isSubmitting">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C14.7545 4 17.1837 5.42027 18.6 7.6"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M15 8H19V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <span>Réinitialiser</span>
            </button>
            <button class="button primary icon medium" (click)="onSubmit()" [disabled]="!isFormValid() || isSubmitting">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
                  stroke="white" stroke-width="1.5" stroke-linejoin="round" />
                  <path d="M12 11V15" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M9 14H15" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <span>Créer</span>
              </button>
              <button class="button neutral icon medium" (click)="onCancel()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 12H4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M10 18L4 12L10 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <span>Annuler</span>
              </button>
            </div>
          </div>
        </div>
        <form [formGroup]="clientForm" class="add-form">
          <!-- Informations de base -->
          <div class="accordion-item" [class.active]="basicInfoExpanded">
            <button class="accordion" type="button" (click)="basicInfoExpanded = !basicInfoExpanded">
              <div class="accordion-elements">
                <div class="accordion-left df-center-8">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="#45B56F" stroke-width="1.5" />
                      <path d="M12 8V12" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                      <path d="M12 16H12.01" stroke="#45B56F" stroke-width="2" stroke-linecap="round" />
                    </svg>
                    <span>Informations de base</span>
                  </div>
                  <div class="accordion-right"><span>{{ basicInfoExpanded ? '▼' : '▶' }}</span></div>
                </div>
              </button>
              <div class="panel" [style.display]="basicInfoExpanded ? 'block' : 'none'">
                <div class="card">
                  <div class="form-grid-2cols">
                    <!-- ID Client -->
                    <div class="field-wrapper">
                      <label>ID Client <sup>*</sup></label>
                      <input type="text" formControlName="clientId" class="field" placeholder="mon-application"
                        (input)="onClientIdChange()">
                        <span class="hint"
                          [class.danger]="clientForm.get('clientId')?.invalid && clientForm.get('clientId')?.touched">{{
                        getFieldError('clientId') }}</span>
                      </div>
                      <!-- Nom -->
                      <div class="field-wrapper">
                        <label>Nom</label>
                        <input type="text" formControlName="name" class="field" placeholder="Mon Application">
                      </div>
                      <!-- Description -->
                      <div class="field-wrapper">
                        <label>Description</label>
                        <textarea formControlName="description" class="field" rows="3"
                        placeholder="Description de l'application"></textarea>
                      </div>
                      <!-- Type de client -->
                      <div class="field-wrapper">
                        <label>Type de client</label>
                        <div class="select-wrapper">
                          <select formControlName="type">
                            @for (t of clientTypes; track t) {
                              <option [value]="t.value">{{ t.label }}</option>
                            }
                          </select>
                        </div>
                      </div>
                      <!-- Root URL -->
                      <div class="field-wrapper">
                        <label>Root URL</label>
                        <input type="url" formControlName="rootUrl" class="field" placeholder="https://mon-app.com">
                      </div>
                      <!-- Base URL -->
                      <div class="field-wrapper">
                        <label>Base URL</label>
                        <input type="url" formControlName="baseUrl" class="field" placeholder="https://mon-app.com/app">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Configuration du client -->
              <div class="accordion-item" [class.active]="configExpanded">
                <button class="accordion" type="button" (click)="configExpanded = !configExpanded">
                  <div class="accordion-elements">
                    <div class="accordion-left df-center-8">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="#45B56F" stroke-width="1.5" />
                      </svg>
                      <span>Configuration du client</span>
                    </div>
                    <div class="accordion-right"><span>{{ configExpanded ? '▼' : '▶' }}</span></div>
                  </div>
                </button>
                <div class="panel" [style.display]="configExpanded ? 'block' : 'none'">
                  <div class="card">
                    <div class="field-wrapper">
                      <label>Protocole</label>
                      <div class="select-wrapper">
                        <select formControlName="protocol">
                          @for (p of protocols; track p) {
                            <option [value]="p.value">{{ p.label }}</option>
                          }
                        </select>
                      </div>
                    </div>
                    <div class="checkbox-section" style="margin-top:12px;">
                      <label class="checkbox-field">
                        <input type="checkbox" formControlName="enabled">
                        <span><strong>Client activé</strong> - Le client peut être utilisé</span>
                      </label>
                    </div>
                    <div class="checkbox-section">
                      <h4>Type de client</h4>
                      <label class="checkbox-field">
                        <input type="checkbox" formControlName="publicClient">
                        <span><strong>Application Publique</strong> - SPA, mobile</span>
                      </label>
                      <label class="checkbox-field">
                        <input type="checkbox" formControlName="bearerOnly">
                        <span><strong>Bearer Only</strong> - API / service</span>
                      </label>
                    </div>
                    <div class="checkbox-section">
                      <h4>Flows OAuth / OIDC</h4>
                      <label class="checkbox-field">
                        <input type="checkbox" formControlName="standardFlowEnabled"
                          [disabled]="$safeNavigationMigration(clientForm.get('bearerOnly')?.value)">
                          <span><strong>Standard Flow</strong> - Authorization Code Flow</span>
                        </label>
                        <label class="checkbox-field">
                          <input type="checkbox" formControlName="implicitFlowEnabled"
                            [disabled]="$safeNavigationMigration(clientForm.get('bearerOnly')?.value)">
                            <span><strong>Implicit Flow</strong> - Déprécié</span>
                          </label>
                          <label class="checkbox-field">
                            <input type="checkbox" formControlName="directAccessGrantsEnabled"
                              [disabled]="$safeNavigationMigration(clientForm.get('bearerOnly')?.value)">
                              <span><strong>Direct Access Grants</strong> - Resource Owner Password</span>
                            </label>
                            <label class="checkbox-field">
                              <input type="checkbox" formControlName="serviceAccountsEnabled"
                                [disabled]="clientForm.get('publicClient')?.value || clientForm.get('bearerOnly')?.value">
                                <span><strong>Service Accounts</strong> - Client Credentials</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- URLs de redirection -->
                      <div class="accordion-item" [class.active]="redirectsExpanded">
                        <button class="accordion" type="button" (click)="redirectsExpanded = !redirectsExpanded">
                          <div class="accordion-elements">
                            <div class="accordion-left df-center-8">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M10 13C10.4295 13.5741 10.9774 14.0491 11.6066 14.3919C12.2357 14.7347 12.9315 14.9372 13.6454 14.9856C14.3593 15.034 15.0739 14.9271 15.7406 14.6709C16.4074 14.4147 17.0091 14.0145 17.5 13.5L20 11C20.9198 10.1129 21.4867 8.92864 21.6006 7.65348C21.7145 6.37831 21.368 5.11639 20.6265 4.07929C19.885 3.04219 18.8015 2.30512 17.5585 1.98733C16.3154 1.66954 14.9997 1.79529 13.8402 2.34L12 3.5"
                                  stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                                  <path
                                    d="M14 11C13.5705 10.4259 13.0226 9.95086 12.3934 9.60812C11.7643 9.26537 11.0685 9.06281 10.3546 9.01445C9.64067 8.96609 8.92608 9.07286 8.25936 9.32908C7.59264 9.5853 6.99091 9.98551 6.5 10.5L4 13C3.08018 13.8871 2.51328 15.0714 2.39939 16.3465C2.28551 17.6217 2.63204 18.8836 3.37352 19.9207C4.115 20.9578 5.19851 21.6949 6.44154 22.0127C7.68457 22.3305 9.00028 22.2047 10.1598 21.66L12 20.5"
                                    stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                                  </svg>
                                  <span>URLs de redirection</span>
                                </div>
                                <div class="accordion-right"><span>{{ redirectsExpanded ? '▼' : '▶' }}</span></div>
                              </div>
                            </button>
                            <div class="panel" [style.display]="redirectsExpanded ? 'block' : 'none'">
                              <div class="card">
                                <div formArrayName="redirectUris">
                                  @for (uri of redirectUris.controls; track uri; let i = $index) {
                                    <div class="field-list">
                                      <input type="url" [formControlName]="i" class="field" placeholder="https://mon-app.com/callback">
                                      <button type="button" class="button-no-style" (click)="removeRedirectUri(i)">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M18 6L6 18" stroke="#EF4025" stroke-width="1.5" stroke-linecap="round" />
                                          <path d="M6 6L18 18" stroke="#EF4025" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                      </button>
                                    </div>
                                  }
                                  <button type="button" class="button dashed-green icon medium" (click)="addRedirectUri()">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M12 4V20" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                                      <path d="M4 12H20" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <span>Ajouter une URL</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Origines web -->
                          <div class="accordion-item" [class.active]="originsExpanded">
                            <button class="accordion" type="button" (click)="originsExpanded = !originsExpanded">
                              <div class="accordion-elements">
                                <div class="accordion-left df-center-8">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                      stroke="#45B56F" stroke-width="1.5" />
                                      <path d="M12 8V12" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                                      <path d="M12 16H12.01" stroke="#45B56F" stroke-width="2" stroke-linecap="round" />
                                    </svg>
                                    <span>Origines web (CORS)</span>
                                  </div>
                                  <div class="accordion-right"><span>{{ originsExpanded ? '▼' : '▶' }}</span></div>
                                </div>
                              </button>
                              <div class="panel" [style.display]="originsExpanded ? 'block' : 'none'">
                                <div class="card">
                                  <div formArrayName="webOrigins">
                                    @for (origin of webOrigins.controls; track origin; let i = $index) {
                                      <div class="field-list">
                                        <input type="url" [formControlName]="i" class="field" placeholder="https://mon-app.com">
                                        <button type="button" class="button-no-style" (click)="removeWebOrigin(i)">
                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18 6L6 18" stroke="#EF4025" stroke-width="1.5" stroke-linecap="round" />
                                            <path d="M6 6L18 18" stroke="#EF4025" stroke-width="1.5" stroke-linecap="round" />
                                          </svg>
                                        </button>
                                      </div>
                                    }
                                    <button type="button" class="button dashed-green icon medium" (click)="addWebOrigin()">
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 4V20" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M4 12H20" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                                      </svg>
                                      <span>Ajouter une origine</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      }